export default "__VITE_ASSET__qOT2NdCH__"